import React, { useEffect } from "react";
import "./AlertModal.css";

export default function AlertModal({
  show,
  message,
  duration = 3000,
  onClose,
}) {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show) return null;

  return (
    <div className="alert-overlay5">
      <div className="alert-modal5">{message}</div>
    </div>
  );
}
